const ROUTE_NAMES: Record<string, string> = {
  '/': 'Tela inicial',
  '/auth': 'Autenticação',
  '/home': 'Página inicial',
  '/analytics': 'Analytics',
  '/users': 'Usuários',
  '/companys': 'Empresas',
  '/logs': 'Sistema de logs',
  '/support': 'Suporte',
  '/alerts/list': 'Lista de alertas',
  '/alerts/new': 'Novo alerta',
  '/reports/pedidos': 'Relatório de pedidos',
  '/reports/promos': 'Relatório de promoções',
  '/reports/notafiscal': 'Relatório de notas fiscais',
  '/reports/cadastro_lojistas': 'Cadastro de lojistas',
  '/reports/cadastro_vendedores': 'Cadastro de vendedores',
  '/reports/apuracao': 'Relatório de apuração',
  '/reports/sellout': 'Relatório de sellout',
  '/reports/historico_preco_estoque': 'Histórico de preço e estoque',
  '/reports/distribuidor_prioritario': 'Distribuidor prioritário',
  '/reports/ultimo_preco_estoque': 'Último preço e estoque',
  '/reports/lojistas': 'Cashback de lojistas',
  '/reports/cupons': 'Cashback de cupons',
  '/reports/politica_preco': 'Política de preço',
  '/reports/lojas_venda_premiada': 'Lojas Venda Premiada',
  '/lojistas/geral': 'Visão geral de lojistas',
  '/lojistas/tabela-reposicao': 'Tabela de reposição',
  '/lojistas/produtos': 'Produtos do lojista',
  '/lojistas/pedido-compra': 'Pedido de compra',
  '/lojistas/pedidos': 'Pré-pedidos e pedidos',
  '/lojistas/importar': 'Importação de dados',
  '/lojistas/fornecedores': 'Fornecedores',
  '/lojistas/usuarios': 'Usuários do lojista',
  '/lojistas/configuracoes': 'Configurações de lojistas',
  '/service-level/dashboard': 'Nível de Serviço',
  '/sales/simulador-campanha': 'Simulador de campanha',
  '/copiloto-do-vendedor/pesquisa': 'Pesquisa por loja',
  '/copiloto-do-vendedor/venda-ai': 'Venda AI',
}

export const isMeaningfulAnalyticsLabel = (value?: string | null) =>
  /[A-Za-zÀ-ÖØ-öø-ÿ0-9]/.test(String(value || ''))

const titleCase = (value: string) => value
  .replace(/[_-]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()
  .replace(/^./, (letter) => letter.toUpperCase())

export const analyticsPageName = (path: string, capturedName?: string | null) => {
  const normalizedPath = path || '/'
  if (ROUTE_NAMES[normalizedPath]) return ROUTE_NAMES[normalizedPath]
  if (/^\/alerts\/:id$/.test(normalizedPath)) return 'Detalhes do alerta'
  if (/^\/:id\/dashboard$/.test(normalizedPath)) return 'Dashboard'
  if (/^\/:id\/api$/.test(normalizedPath)) return 'API do dashboard'
  if (/^\/support\/:id$/.test(normalizedPath)) return 'Detalhes do suporte'

  const captured = String(capturedName || '').trim()
  if (isMeaningfulAnalyticsLabel(captured) && !/^insight experience$/i.test(captured)) {
    return captured
  }
  const parts = normalizedPath.split('/').filter(Boolean).filter((part) => part !== ':id')
  return parts.length ? titleCase(parts[parts.length - 1]) : 'Tela inicial'
}
